
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../context/AppProvider';
import useQuaterListHook from '../../hooks/useQuaterListHook';
import useSubscription from '../../hooks/useSubscription';
import { highLight, isEnrollmentDateAvailable } from '../../lib/utils';
import { apis } from '../../services/alm';
import PageLoader from "../common/loader/PageLoader";
import MeetingCalendar from '../common/MeetingCalendar';
import withAlmToken from '../common/withAlmToken';
import QuaterWiseData from './QuaterWiseData';

const QuaterList = () => {
  const {t} = useTranslation();
  const [quaterWiseDataList, setQuarterWiseDataList] = useState([]);
  const {currentQuater, quaterListData, getQuaterStartData} = useQuaterListHook(quaterWiseDataList);
  const [enroledProgram,setIsEnrolledProgram]=useState([])
  const {state} = useContext(AppContext);

  const {callSubscription} = useSubscription();
  useEffect(() => {
    if(state.user){
      if(!state.user?.corporateAccountId)
        callSubscription("valid");
    }
  }, [state.user]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, []);
  useEffect(() => {
    if (quaterListData) {
      modifiedQuaterData(quaterListData);
    }
    
  }, [quaterListData]);
  const apiCall = async (quaterTag: any) => {
    try {
      const response: any = await apis.getLearningProgram(quaterTag);
      const enrolledData = response?.data?.filter((item: any) => {
        return item.relationships.enrollment;
      });
      setIsEnrolledProgram(enrolledData)
      return enrolledData?.length;
    } catch (error) {
      console.log(error);
    }
  };

  const modifiedQuaterData = (quaterListingdata: any) => {
    const q = getQuaterStartData(currentQuater);
    const quaterTag = q?.quarter + '-' + q?.year;
    apiCall(quaterTag).then((res: any) => {
      if (res || isEnrollmentDateAvailable(q?.start)) {
        setQuarterWiseDataList(quaterListingdata.slice(0, 4));
      } else {
        setQuarterWiseDataList(quaterListingdata.slice(1,5));
      }
    });
  };


   const isEnrollmentOpenForAnyQuarter =[quaterWiseDataList[0]]?.map((item:any)=>isEnrollmentDateAvailable(item?.start))
   return (
    <div className="flex-grow">
      {quaterWiseDataList.length === 0 ? (
        <PageLoader />
      ) : (
        <>
          <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 lg:mb-6">
            <MeetingCalendar />
          </div>
          <div className="w-[100%] mx-auto px-4 py-4 md:py-0 xl:px-32 md:px-8 lg:px-8">
            <div className="lg:flex lg:items-center lg:justify-between">
              <div className="min-w-0 flex-1">
                <h1 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light">
                  <span dangerouslySetInnerHTML={{ __html: t('QuarterList.headingName') }} />
                </h1>
                {isEnrollmentOpenForAnyQuarter[0] ? (
                   !enroledProgram.length && (
                    <p className="mt-[1rem]">
                    <span dangerouslySetInnerHTML={{ __html: t('MyStance.enrollmentOnHeading') }} />
                    <span dangerouslySetInnerHTML={{ __html: t('MyStance.enrollmentOnMessage') }} />
                    </p>
                  )) : (
                  !enroledProgram.length && (
                  <p className="mt-[1rem]">
                  <span dangerouslySetInnerHTML={{ __html: t('MyStance.heading') }} />
                  <span dangerouslySetInnerHTML={{ __html: t('MyStance.enrollmentNotification') }} />
                  </p>)
                )}

              </div>
            </div>
          </div>
          {quaterWiseDataList?.map((res: any, index: number) => {
            return (
              <div
                key={`quater-list-${index}`}
                className="w-[100%] mx-auto md:py-10 last-of-type:mb-20 xl:px-32 md:px-8 lg:px-8 px-5 max-md:mb-8"
              >
                <div className="flex items-center justify-between mb-9">
                  <h4
                    className={`racking-tight leading-7 text-3xl md:text-4xl font-barlowLight ${
                      highLight(res, currentQuater, getQuaterStartData) ||
                      isEnrollmentDateAvailable(res?.start)
                        ? 'text-primary'
                        : 'text-[#767676]'
                    }`}
                  >
                    {res?.quarter}
                  </h4>
                  <p
                    className={`font-normal py-1 h-9 text-4xl  ${
                      highLight(res, currentQuater, getQuaterStartData) || 
                      isEnrollmentDateAvailable(res?.start) 
                        ? 'text-primary'
                        : 'text-[#767676]'
                    }`}
                  >
                    {res?.year}
                  </p>
                </div>
                
                <QuaterWiseData
                  quaterTag={res?.quarter + '-' + res?.year}
                  currentQuater={currentQuater}
                  startDate={res?.start}
                  getQuaterStartData={getQuaterStartData}
                  setIsEnrolledProgram={setIsEnrolledProgram}
                />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};
export default withAlmToken(QuaterList);
